import React from "react";
import { useTranslation } from "react-i18next";
import { RolloverRecommendationAction } from "@/features/planner/enums";
import { FollowUpPresentationRow, FollowUpStudentRec } from "@/hooks";
import { BadgeWithTooltip } from "@/features/wizard/components";
import { RolloverIcon, SkilltreeIcon, TeacherInstructionIcon, TutorIcon, EditIcon } from "@/features/planner/icons";

interface FollowUpRowProps {
  row: FollowUpPresentationRow;
  onEditClick: () => void;
}

const recommendationIcon: Partial<Record<RolloverRecommendationAction, React.ReactNode>> = {
  [RolloverRecommendationAction.CompleteAssignments]: <i className="icon"><RolloverIcon /></i>,
  [RolloverRecommendationAction.AddSkillTutoring]: <i className="icon"><TutorIcon /></i>,
  [RolloverRecommendationAction.RecommendPrerequisite]: <i className="icon"><SkilltreeIcon /></i>,
  [RolloverRecommendationAction.TeacherInstruction]: <i className="icon"><TeacherInstructionIcon /></i>,
};

const recommendationLabel: Partial<Record<RolloverRecommendationAction, string>> = {
  [RolloverRecommendationAction.CompleteAssignments]: 'INCOMPLETE',
  [RolloverRecommendationAction.AddSkillTutoring]: 'TUTOR',
  [RolloverRecommendationAction.RecommendPrerequisite]: 'PREREQ',
  [RolloverRecommendationAction.TeacherInstruction]: 'TEACHER',
};

export const FollowUpRow: React.FC<FollowUpRowProps> = ({ row, onEditClick }) => {
  const { t } = useTranslation("rolloverWizard");

  const recommendationCount = ({fulfillment}: FollowUpStudentRec) => fulfillment?.length ?? 0;

  return row.students.map((s, idx) => {
    const firstName = (s as any).first_name;
    const lastName = (s as any).last_name;
    const fullName = firstName && lastName ? `${firstName} ${lastName}` : s.name;
    
    return s ? /*s.fulfillment && s.fulfillment.length > 0 ? */ (
      <tr key={s.id}>
        {
        /* Only render skillName cell for the first student */
        idx === 0 && (
          <td className="" rowSpan={row.students.length}>{row.displayName}</td>
        )}
        <td>
          <BadgeWithTooltip
            fullName={fullName}
            firstName={firstName}
            displayName={row.skillName}
            errorCount={s.errorCount}
            exposureCount={s.exposureCount}
            masteryNow={s.masteryNow}
            showIcon={false}
            template={'TIME_NEEDED'}
          />
        </td>
        <td>
          {/* Recommendation Icon & Label */}
          <span className="d-inline-flex justify-content-start align-items-start gap-1">
            {recommendationIcon[s.recommendedAction] ?? <span>✅</span>}
            <span>{t(recommendationLabel[s.recommendedAction] ?? '', { count: recommendationCount(s)})}</span>
          </span>
        </td>

        {/* Edit */}
        <td>
          <button 
            className="btn btn-link" 
            style={{ background: "none" }}
            onClick={(e) => {
              e.stopPropagation();
              onEditClick?.();
            }}
          >
            <EditIcon color="currentColor"/>
          </button>
        </td>

      </tr>
    ) : null;
  });
};
